import React, { useRef, useState } from 'react';
import { Box } from "@material-ui/core";

import AdminUserAddForm from "../Component/User/AdminUserAddForm";
import { useRouteMatch } from "react-router-dom";
// import AppTabs from "../../../components/CustomTabs/AppTabs";
import { useTranslation } from "react-i18next";
import AdminUserSettingForm from "../Component/User/AdminUserSettingForm";
import AdminUserDetailForm from "../Component/User/AdminUserDetailForm";
import ChangePasswordForm from "views/Client/AccountSetting/Components/ChangePasswordForm";
import ChangeEmailForm from "views/Client/AccountSetting/Components/ChangeEmailForm";
import { changeEmail, changePassword } from "store/slices/auth";
import { useDispatch, useSelector } from 'react-redux';
import { getAuthInfo } from 'store/slices/auth';
import { SYSTEM_ROLE } from 'config/AppConfig';
import ScrollableTabs from 'components/CustomTabs/AppTabsScroll';

const AdminUserDetail = () => {
    const { t } = useTranslation();
    const { path } = useRouteMatch();

    const dispatch = useDispatch();

    const cpRef = useRef();
    const ceRef = useRef();

    const user = useSelector(getAuthInfo);

    const [loading, setLoading] = useState(false);

    const submitChangePassword = async ({ confirmPass, newPass, id }) => {
        setLoading(true);
        if (confirmPass && newPass) {
            const result = await dispatch(changePassword({
                id: id,
                confirmPass: confirmPass,
                newPass: newPass
            }));
            if (result.payload) {
                cpRef && cpRef.current.resetForm();
            }
        }
        setLoading(false);
    };
    const submitChangeEmail = async ({ email, id }) => {
        setLoading(true);
        if (email) {
            const result = await dispatch(changeEmail({
                id: id,
                email: email.trim()
            }));
            if (result.payload) {
                ceRef && ceRef.current.resetForm();
            }
        }
        setLoading(false);
    };

    return (
        <Box>
            {path.includes('detail') ? (
                <ScrollableTabs
                    swipeable={false}
                    tabs={[
                        {
                            tabLabel: t('label.user_profile'),
                            tabContent: <AdminUserDetailForm />,
                        },
                        {
                            tabLabel: t('label.change_password'),
                            tabContent: <React.Fragment>
                                {user.role !== SYSTEM_ROLE.COMPANY &&
                                    <ChangeEmailForm
                                    isSubmitting={loading}
                                    onSubmit={submitChangeEmail}
                                    formRef={ceRef}
                                />
                                }
                                <ChangePasswordForm
                                    isSubmitting={loading}
                                    onSubmit={submitChangePassword}
                                    formRef={cpRef}
                                />
                            </React.Fragment>,
                        },
                        {
                            tabLabel: t('label.settings'),
                            tabContent: <AdminUserSettingForm />,
                        }
                    ]}
                />
            ) : (
                <AdminUserAddForm />
            )}
        </Box>
    )
}

export default AdminUserDetail;